export type UpdateComponentAttributeTicketStatusesRequest = {
  updateCpntTcktList: UpdateCpntTckt[];
};
export type UpdateCpntTckt = {
  idx: number;
  pjtId: string;
  evntGrpTypeCd: string;
  tcktTypeTypeCd: string;
  tcktStsTypeCd: string;
  cmnt?: string;
};
